import React, { useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import SimpleJsonExportButton from "components/basic/simple-json-export-button/SimpleJsonExportButton";
import { FormattedDataForExportProps } from "components/basic/datasets-properties/DatasetsPropertiesTable";
import CreateSingleDataset from "./create-single-dataset/CreateSingleDataset";
import CreateMultipleDatasets from "./create-multiple-datasets/CreateMultipleDatasets";

interface CreateDatasetDialogProps {
  setCreateDialogVisibility: (value: boolean) => void;
}

enum DatasetsTypes {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}

const CreateDatasetDialog = ({ setCreateDialogVisibility }: CreateDatasetDialogProps) => {
  const [datasetCreationType, setDatasetCreationType] = useState(DatasetsTypes.SINGLE);
  const [formattedDataForExport, setFormattedDataForExport] = useState<
    Array<FormattedDataForExportProps>
  >([]);

  return (
    <div className="flex flex-column">
      <div className="flex flex-row justify-content-between">
        <div className="flex mb-2">
          <div className="flex gap-1 align-items-center">
            <RadioButton
              inputId="single"
              name="datasetCreationType"
              value={DatasetsTypes.SINGLE}
              onChange={e => {
                setDatasetCreationType(e.value);
                setFormattedDataForExport([]);
              }}
              checked={datasetCreationType === DatasetsTypes.SINGLE}
            />
            <label htmlFor="single" className="p-radiobutton-label mr-2">
              Single
            </label>
          </div>
          <div className="flex gap-1 align-items-center">
            <RadioButton
              inputId="multiple"
              name="datasetCreationType"
              value={DatasetsTypes.MULTIPLE}
              onChange={e => {
                setDatasetCreationType(e.value);
                setFormattedDataForExport([]);
              }}
              checked={datasetCreationType === DatasetsTypes.MULTIPLE}
            />
            <label htmlFor="multiple" className="p-radiobutton-label">
              Multiple
            </label>
          </div>
        </div>
        <div>
          {formattedDataForExport.length > 0 && (
            <SimpleJsonExportButton
              data={formattedDataForExport}
              filename="dataset-properties.json"
            />
          )}
        </div>
      </div>

      {datasetCreationType === DatasetsTypes.SINGLE && (
        <CreateSingleDataset setCreateDialogVisibility={setCreateDialogVisibility} />
      )}
      {datasetCreationType === DatasetsTypes.MULTIPLE && (
        <CreateMultipleDatasets
          setCreateDialogVisibility={setCreateDialogVisibility}
          setFormattedDataForExport={setFormattedDataForExport}
        />
      )}
    </div>
  );
};

export default CreateDatasetDialog;
